import React from 'react';

const NormalText = ({ children, classes }) => (
  <p className={`text-lg text-gray-700 font-sf-regular ${classes}`}>{children}</p>
);

const Heading = props => <h4 className={`font-sf-normal ${props.className}`}>{props.children}</h4>;

export { NormalText, Heading };
